import React from "react";
import VacancyAlert from "./VacancyAlert";
import qrcode from "../images/qrcode/qrcode_1.jpg"
const Testimonials = () => {
  return (
    <div className="col s12 homeWrapper">
      <VacancyAlert />
      <h5 className="blue-text text-lighten-2">Testimonials</h5>
      <p className="grey-text text-darken-2">
        We collect feedback from parents and carers in different ways for us to improve our service.
        Here are some examples:
      </p>
      <div>
      <img
        src={qrcode}
        className="modal-content"
        id={"img_0_qrcode"}
        alt="children"
      />
      </div>
      <h6 className="blue-text text-lighten-2">
        From the survey and quality of provision questionnaires:
      </h6>
      <p className="grey-text text-darken-2">
        I prefer this preschool as my son is learning more. I am just very happy
        with this preschool
      </p>
      <p className="grey-text text-darken-2">
        Everything here is perfect. My son is happy, and the staff are very
        helpful and friendly. They are always very helpful if I need some
        advice, they give me information
      </p>
      <p className="grey-text text-darken-2">
        I am very happy with the service and the process
      </p>
      <p className="grey-text text-darken-2">
        I have seen a lot of different in my child
      </p>
      <p className="grey-text text-darken-2">
        The preschool caters for my son’s needs amazingly. My son continues to
        develop in all areas. Continue being a warm welcoming setting. I am very
        happy with all service. I loved the farm trip, and it was really nice to
        interact with everyone. Great team building
      </p>
      <p className="grey-text text-darken-2">
        The admission process is very smooth and effective. Staff are very
        helpful and easy to approach them
      </p>
      <p className="grey-text text-darken-2">
        My son is happy, and I see a lot of development in his language
      </p>
      <p className="grey-text text-darken-2">
        I am happy that my child is learning lots of new things. She sings more
        nursery rhymes now and she knows the primary colours
      </p>
      <p className="grey-text text-darken-2">
        I don’t think you need to develop. You are doing a great job
      </p>
      <p className="grey-text text-darken-2">
        He started to talk in English and sings songs at home
      </p>
      <p className="grey-text text-darken-2">
        The teachers are very friendly and supportive
      </p>
      <h6 className="blue-text text-lighten-2">
        From Parents WhatsApp group:
      </h6>
      <p className="grey-text text-darken-2">
        Thank you very much for taking a wonderful care and making learning so
        much fun
      </p>
      <p className="grey-text text-darken-2">
        My dear staff, thank you most sincerely for being so good to all the
        children in your care. The twins absolutely adore all their teachers and
        their school mates. God bless you all in this school
      </p>
      <p className="grey-text text-darken-2">
        Wow you guys are just the best. You all are worth it. You ladies are
        caring for our most precious possessions. You deserved to be appreciated
      </p>
      <p className="grey-text text-darken-2">
        My son attends with great pleasure. You all are great fellows, and you
        all are a great team
      </p>
      <p className="grey-text text-darken-2">
        You all are just wonderful educators
      </p>
      <p className="grey-text text-darken-2">
        Thanks for your hard work and support this term. She enjoyed coming in
      </p>
      <p className="grey-text text-darken-2">
        you girls are just amazing. You never cease to amaze me with every thing
        you ladies do. Thank you so much
      </p>
      <p className="grey-text text-darken-2">
        Thank you so much all of you for the amazing work
      </p>
      <p className="grey-text text-darken-2">
        {" "}
        Thank you ladies! You are amazing!
      </p>
      <p className="grey-text text-darken-2">
        Thank you for your time and patience this years in talking with me about
        my children\’s development. I had so many questions but you made me feel
        perfectly comfortable. Your commitment to my children in the rigorous
        academic environment in nursery. It is such a good feeling to know that
        they will be to enter next year as confident students, and this is
        because of you. You are a wonderful team! I will never forget you. You
        are the best!
      </p>
      <p className="grey-text text-darken-2">
        We are so lucky that our daughter is registered in this nursery
      </p>
      <p className="grey-text text-darken-2">
        A is looking forward to coming to preschool. He hasn’t stop talking
        about his school, friends and teachers
      </p>
      <p className="grey-text text-darken-2">
        Thank you to all the preschool teachers for all your hard work, care ,
        over the years towards my daughter
      </p>
      <p className="grey-text text-darken-2">
        E learns so much from you and has fun. Thank you for everything that you
        do for our children
      </p>
      <p className="grey-text text-darken-2">
        Thank you so much for all your hard work and so much efforts
      </p>
      <br />
      <hr />
      <h5 className="blue-text text-lighten-2">
        Transition documents Comments that go to the prospective schools:
      </h5>
      <p className="grey-text text-darken-2">
        ..helpful and understanding of my son's needs'
      </p>
      <p className="grey-text text-darken-2">'I like everything'</p>
      <p className="grey-text text-darken-2">
        'very friendly, and helpful with any issues'
      </p>
      <p className="grey-text text-darken-2">
        'the informative, warm and caring environment for the children'
      </p>
      <p className="grey-text text-darken-2">
        'All Saint's has been wonderful experience for my daughter, making
        friends, enjoying a variety of activities, I would not hesitate in
        recommending All Saint's'
      </p>
      <p className="grey-text text-darken-2">
        'has gained so much confidence and independence...due to staff and their
        approach to children....warm and friendly...a great stepping stone to
        school'
      </p>
      <p className="grey-text text-darken-2">
        'we feel welcome every time.....told of daughters progress daily'
      </p>
      <br />
      <hr />
      <h5 className="blue-text text-lighten-2">
        Parents comments in their children's progress report
      </h5>
      <p className="grey-text text-darken-2">
        'I am so pleased...on how far she has come from where she started'
      </p>
      <p className="grey-text text-darken-2">
        'I'd like to thank the entire team for their love, support and
        dedication to .....development'
      </p>
      <p className="grey-text text-darken-2">
        'very pleased that she has attended this pre-school.met great teachers
        and friends'
      </p>
      <p className="grey-text text-darken-2">
        'she has developed well....we have been very happy with her progress at
        pre-school'
      </p>
      <p className="grey-text text-darken-2">
        'thank you for everything you have done over the past two years'
      </p>
      <p className="grey-text text-darken-2">
        'thank you for your dedication towards my daughters development'
      </p>
      <p className="grey-text text-darken-2">
        'don't know where to begin.....for making N feel so happy and
        settled....such happy memories. pre-school in a million....you should be
        very proud of yourselves.
      </p>
    </div>
  );
};

export default Testimonials;
